import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'error-block',
    templateUrl: './error-block.component.html',
    styleUrls: ['./error-block.component.scss'],
    standalone: false
})
export class ErrorBlockComponent implements OnInit {

    @Input() field: AbstractControl;
    @Input() messages: { [key: string]: string };

    keys = Object.keys;

    constructor() { }

    ngOnInit(): void {
    }

}
